<template>
  <div class="detatil">
    <iframe
      id="mainContent"
      width="100%"
      height="100%"
      style="width:100%;height:100%;"
      frameborder="0"
      scrolling="no"
      :src="url"
      webkitallowfullscreen=""
      mozallowfullscreen=""
      allowfullscreen=""
    ></iframe>
    <img
      class="back-icon"
      src="../assets/home@2x.png"
      alt=""
      @click="goBack()"
    >
    <img
      class="info-icon"
      src="../assets/dingzhi@2x.png"
      alt=""
      @click="goInfo()"
    >
    <img class="share-icon" v-if="isInsideMiniProgram" src="https://hsimage.fotile.com/202307031705345508988.png" alt=""  @click="setMiniProgramMessage()" />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      url: "",
      shareItems: {},
      isInsideMiniProgram:false,
      saleId:''
    };
  },
  created() {
    if(this.$route.query.isInsideMiniProgram==1){
      this.isInsideMiniProgram=true
    }else{
      this.isInsideMiniProgram=false
    }
  },
  mounted() {
    let that = this;
    var nshareId = that.$route.query.shareId;
    // 获取内容详情
    that.$api.article
    .getContentDetail({
      id: nshareId,
    })
    .then((res) => {
      that.shareItems = res.data.data;
      document.title = res.data.data.title;
      that.url = res.data.data.panoramaUrl;
    })
    .catch((err) => {
    })
    .finally((all) => {
       // test share
      that.$api.article
        .querySign({
          type: 1,
        })
        .then((res) => {
          // let jsApiList = ["updateAppMessageShareData", "updateTimelineShareData","onMenuShareAppMessage","onMenuShareTimeline"];
          // let List = res.data.jsApiList;
          // let nList = List.substr(1);
          // nList = nList.substring(0, nList.length-1);
          // let nList2 = nList.split(',');
         
          //  nList2.forEach(element => {
          //    console.log('change',element.trim() )
          //   element = element.trim() 
          // });
          // for(let i = 0; i< nList2.length; i++){
          //    nList2[i] = nList2[i].trim();
          // }
          // for(let j = 0; j< jsApiList.length; j++){
          //   if(nList2[j] == "updateAppMessageShareData" || nList2[j] == "updateTimelineShareData"){
          //     jsApiList =  ["onMenuShareAppMessage","onMenuShareTimeline"];
          //   }else if(nList2[j] == "onMenuShareAppMessage" || nList2[j] == "onMenuShareTimeline"){
          //     jsApiList =  ["updateAppMessageShareData", "updateTimelineShareData"];
          //   }
          // }
          
          
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            // jsApiList :jsApiList,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的js接口列表
          });
          wx.ready(function() {
            console.log('准备',that.shareItems.title,that.shareItems.panoramaCoverUrl)
            // //分享给朋友
            //   if (wx.updateAppMessageShareData) {
            //     wx.updateAppMessageShareData({
            //       title: "方太厨电顾问为您定制了专属厨房解决方案", // 分享标题
            //       desc: that.shareItems.title, // 分享描述 summary
            //       link: `${location.href.split("#")[0]}#/detailLink?shareId=${nshareId}`,
            //       imgUrl:that.shareItems.panoramaCoverUrl +"?x-oss-process=image/resize,m_fixed,h_200,w_200,limit_0", // 分享图标
            //       success: function() {
            //         // 设置成功
            //       },
            //     });
            //   } else {
            //     wx.onMenuShareAppMessage({
            //       title: "方太厨电顾问为您定制了专属厨房解决方案", // 分享标题
            //       desc: that.shareItems.title, // 分享描述 summary
            //       link: `${location.href.split("#")[0]}#/detailLink?shareId=${nshareId}`,
            //       imgUrl:that.shareItems.panoramaCoverUrl +"?x-oss-process=image/resize,m_fixed,h_200,w_200,limit_0", // 分享图标
            //       success: function() {
            //         // 设置成功
            //       },
            //     });
            //   }
            //   //分享给朋友圈
            //   if (wx.updateTimelineShareData) {
            //     wx.updateTimelineShareData({
            //       title: "方太厨电顾问为您定制了专属厨房解决方案", // 分享标题
            //       desc: that.shareItems.title, // 分享描述 summary
            //       link: `${location.href.split("#")[0]}#/detailLink?shareId=${nshareId}`,
            //       imgUrl:that.shareItems.panoramaCoverUrl +"?x-oss-process=image/resize,m_fixed,h_200,w_200,limit_0", // 分享图标
            //       success: function() {
            //         // 设置成功
            //       },
            //     });
            //   } else {
            //     wx.onMenuShareTimeline({
            //       title: "方太厨电顾问为您定制了专属厨房解决方案", // 分享标题
            //       desc: that.shareItems.title, // 分享描述 summary
            //       link: `${location.href.split("#")[0]}#/detailLink?shareId=${nshareId}`,
            //       imgUrl:that.shareItems.panoramaCoverUrl +"?x-oss-process=image/resize,m_fixed,h_200,w_200,limit_0", // 分享图标
            //       success: function() {
            //         // 设置成功
            //       },
            //     });
            //   }

            wx.updateAppMessageShareData({
              title: "方太厨电顾问为您定制了专属厨房解决方案", // 分享标题
              desc: that.shareItems.title, // 分享描述 summary
              link: `${location.href.split("#")[0]}#/detailLink?shareId=${nshareId}`,
              imgUrl:that.shareItems.panoramaCoverUrl +"?x-oss-process=image/resize,m_fixed,h_200,w_200,limit_0", // 分享图标
              success: function() {
                // 设置成功
              },
            });
            wx.updateTimelineShareData({
              title: "方太厨电顾问为您定制了专属厨房解决方案", // 分享标题
              desc: that.shareItems.title, // 分享描述 summary
              link: `${location.href.split("#")[0]}#/detailLink?shareId=${nshareId}`,
              imgUrl:that.shareItems.panoramaCoverUrl + "?x-oss-process=image/resize,m_fixed,h_200,w_200,limit_0", // 分享图标
              success: function() {
                // 设置成功
              },
            });
            
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    });


    //iframe-宽高自适应显示
    const oIframe = document.getElementById("mainContent");
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.width = Number(deviceWidth) + "px";
    oIframe.style.height = Number(deviceHeight) + "px";
    this.saleId=this.getQueryString('saleId')
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/",
        query: { timeNum: new Date().getTime() },
      });
    },
    goInfo(){
      this.$router.push({
        path: "/info",
        query: { timeNum: new Date().getTime() },
      });
    },
    getQueryString (name, search)  {
      search = search ||  window.location.search.substr(1) || window.location.hash.split("?")[1];
      let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      let r = search.match(reg);
      if (r != null) return  unescape(r[2]); return null;
    },
    setMiniProgramMessage(){
      const query=this.getQueryString('shareId')
      wx.miniProgram.navigateTo({
					url: "/pages/kitchen/case/3dCasePoster?query=" + query 
				})
    },
  },
};
</script>

<style scoped>
.detatil {
  width: 100%;
  height: 100%;
}
iframe {
  border: 0;
}
.back-icon {
  width: 50px;
  height: 50px;
  position: absolute;
  bottom: 120px;
  z-index: 9999;
  right: 0;
}
.info-icon{
  width: 50px;
  height: 50px;
  position: absolute;
  bottom: 60px;
  z-index: 9999;
  right: 0px;
}
.share-icon{
  width: 50px;
  height: 50px;
  position: absolute;
  bottom: 180px;
  z-index: 9999;
  right: 0px;
  color: black;

}
</style>